import React, { useState, useEffect } from 'react';

const UpdateControl = () => {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/chairman/overview', {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    })
      .then(r => r.json())
      .then(d => { setTenants(d.tenants || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div style={{padding:'20px',color:'#94a3b8'}}>Loading...</div>;

  return (
    <div style={{padding:'20px'}}>
      <h2 style={{color:'#7c3aed',marginBottom:'4px'}}>🚀 Update Control</h2>
      <p style={{color:'#64748b',marginBottom:'24px',fontSize:'13px'}}>Manage deployments across all tenant instances</p>

      <div style={{background:'#1e293b',borderRadius:'12px',padding:'20px',border:'1px solid #f59e0b33',marginBottom:'24px'}}>
        <div style={{color:'#f59e0b',fontWeight:'bold',marginBottom:'8px'}}>⚠️ Coming Soon</div>
        <p style={{color:'#94a3b8',margin:0,fontSize:'13px'}}>
          Automated update push and rollback system is under development. 
          For now, updates can be applied manually via SSH to each tenant VM.
        </p>
      </div>

      <h3 style={{color:'#e2e8f0',marginBottom:'16px'}}>Tenant Instances</h3>
      {tenants.map(t => (
        <div key={t.businessId} style={{
          background:'#1e293b',borderRadius:'12px',padding:'16px',
          marginBottom:'12px',border:'1px solid #334155'
        }}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div>
              <h3 style={{color:'#e2e8f0',margin:0}}>{t.name}</h3>
              <p style={{color:'#64748b',margin:'4px 0',fontSize:'12px'}}>{t.url || 'No URL'}</p>
            </div>
            <div style={{display:'flex',gap:'8px'}}>
              {t.url && (
                <a href={t.url} target="_blank" rel="noreferrer" style={{
                  background:'rgba(124,58,237,0.1)',color:'#7c3aed',
                  padding:'8px 16px',borderRadius:'8px',textDecoration:'none',
                  fontSize:'13px',border:'1px solid rgba(124,58,237,0.3)'
                }}>SSH Access</a>
              )}
              <button style={{
                background:'rgba(59,130,246,0.1)',color:'#3b82f6',
                padding:'8px 16px',borderRadius:'8px',fontSize:'13px',
                border:'1px solid rgba(59,130,246,0.3)',cursor:'not-allowed',
                opacity:0.5
              }} disabled>Push Update</button>
              <button style={{
                background:'rgba(239,68,68,0.1)',color:'#ef4444',
                padding:'8px 16px',borderRadius:'8px',fontSize:'13px',
                border:'1px solid rgba(239,68,68,0.3)',cursor:'not-allowed',
                opacity:0.5
              }} disabled>Rollback</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UpdateControl;
